import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import { __t } from "@core/translation/translation";
import useStyles from "./styles";

const EXFALoader = () => {
  const classes = useStyles();
  const { promiseInProgress } = usePromiseTracker({ delay: 300 });
  const theme = window.localStorage.getItem("theme");

  if (promiseInProgress) {
    return (
      <div className={"vertical-centered-box"}>
        <div className={"content"}>
          <div className={"loader-circle"}></div>
          <div className={"loader-line-mask"}>
            <div
              className={theme === "LIGHT" ? "loader-line" : "loader-line-dark"}
            ></div>
          </div>
          <img
            alt={"logo"}
            height={36}
            src={
              theme === "LIGHT"
                ? "/static/icons/Logo/Logo.svg"
                : "/static/icons/Logo/Logo2.svg"
            }
            className={classes.ExfaLogo}
          />
        </div>
      </div>
    );
  }
  return null;
};

export default EXFALoader;
